import { render, staticRenderFns } from "./alkali.vue?vue&type=template&id=27ec3de5&"
import script from "./alkali.vue?vue&type=script&lang=js&"
export * from "./alkali.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports